import PropTypes from 'prop-types';
import { Durations, Features } from '../constants';
import { ContentsDefaults, ContentsProps } from './contents';
import { AttendeeGroupsProps, AttendeeGroupsDefaults } from './attendeeGroups';

export const PassTypeProps = PropTypes.shape({
  id: PropTypes.string,
  facility_id: PropTypes.string,
  name: PropTypes.string,
  contents: ContentsProps,
  image: PropTypes.string,
  used_for: PropTypes.string,
  sku: PropTypes.string,
  price: PropTypes.number,
  clin: PropTypes.number,
  duration: PropTypes.oneOf(Object.keys(Durations)),
  features: PropTypes.arrayOf(PropTypes.oneOf(Features)),
  groups: AttendeeGroupsProps,
  sales_available_start: PropTypes.string,
  sales_available_end: PropTypes.string,
  created_at: PropTypes.string,
  updated_at: PropTypes.string
});

export const PassTypeDefaults = {
  id: null,
  facility_id: null,
  name: '',
  contents: ContentsDefaults,
  image: '',
  used_for: '',
  sku: '',
  price: 0,
  clin: 0,
  duration: 'annual',
  features: [],
  groups: AttendeeGroupsDefaults,
  sales_available_start: '',
  sales_available_end: '',
  created_at: '',
  updated_at: ''
};
